export const environment = {
    logger: { //logger.service
        enabled: true,
        level: 'info', //Possible values: 'debug' > 'info' > 'warning' > 'error'
    },
    userPreferences: {
        alwaysAutoexpandNodes: false, // when cloning nodes always autoexpand cloned node including if original node not expanded
        autoexpandNodesOnCloning: false, // when cloning nodes autoexpand cloned nodes only if original node is expanded 
    },
    apiUrl: 'https://eudravigilance-xevmpd-xcomp.ema.europa.eu',
    eudravigilanceUrl: 'https://eudravigilance-human-xcomp.ema.europa.eu/#/',
    clientId: '9051d639-7d4e-4cb3-90b6-b4023d582ad1', 
    authority: 'https://login.microsoftonline.com/bc9dc15c-61bc-4f03-b60b-e5b6d8922839', 
    redirectUri: 'https://eudravigilance-xevmpd-xcomp.ema.europa.eu',
    serviceDeskURL: 'https://support.ema.europa.eu',
    scope: '9051d639-7d4e-4cb3-90b6-b4023d582ad1',
    frontendVersion: 'XCOMP',
    emaOrganisations: ["EVTEST","EVTESTWT"],
    maxNumberRowsReturned: 50,
    lookupDebounceMs: 300,
    name:'xcomp',
    successElapsedTime: 2000,
    warningElapsedTime: 3000,
    errorElapsedTime: 3000,
    inactivityTime: 1800000, //30 minutes
    inactivityWarningTime: 1500000, //25 minutes
    maxZipFileByteSizeEvpost: 62914560,
    maxCumulativeByteSize: 62914560, // 60 MB
    maxIndividualByteSize: 26214400 // 25 MB
};